module.exports = __webpack_public_path__ + "img/워든.411137fb.png";